// src/reducers/reportReducer.js
import {
    FETCH_CHILDREN_WITH_REPORT_STATUS_SUCCESS,
    CREATE_REPORT_SUCCESS,
    FETCH_REPORTS_BY_DATE_SUCCESS,
  } from '../actions/reportActions';
  
  const initialState = {
    childrenWithStatus: [],
    reportsByDate: [],
  };
  
  const reportReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CHILDREN_WITH_REPORT_STATUS_SUCCESS:
            return { ...state, childrenWithStatus: action.payload };
        case CREATE_REPORT_SUCCESS:
            if (!action.payload || !action.payload.child_id) {
              return state;
            }
            return {
              ...state,
              childrenWithStatus: state.childrenWithStatus.map((child) =>
                child.child_id === action.payload.child_id
                  ? { ...child, reportSent: true }
                  : child
              ),
            };
        case FETCH_REPORTS_BY_DATE_SUCCESS:
            return {
                ...state,
                reportsByDate: action.payload,
            };
      default:
        return state;
    }
  };
  
  export default reportReducer;
  
